import { createGlobalStyle } from "styled-components";

const PalleteStyles = createGlobalStyle`
    .text-primary{
        color: var(--primary) !important;
    }
`;

export default PalleteStyles;